module.exports = __webpack_public_path__ + "static/img/cont3002.a86968f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/news/cont3002.jpg
// module id = SESu
// module chunks = 0